import { show, hide, trigger } from './utility';

/// show-depends-on-select is used when a section need to be hided based on a select element

/// <div data-gs-toggle="show-depends-on-select" data-gs-target="targetName" data-gs-show-value="other"></div>
/// <div data-gs-toggle="show-depends-on-select" data-gs-target="targetName" data-gs-hide-value="other"></div>
/// Note: the data-gs-hide-value version will also hide when slect value is ''
/// <div data-gs-toggle="show-depends-on-select" data-gs-target="targetName" data-gs-show-regex="other"></div>
/// <div data-gs-toggle="show-depends-on-select" data-gs-target="targetName" data-gs-hide-regex="other"></div>
/// Note: the data-gs-hide-regex version will also hide when slect value is ''

export default function (targetElem: HTMLElement) {
    let selectName = targetElem.dataset['gsTarget'];
    let selectElems = document.getElementsByName(selectName);
    if (selectElems.length == 0) {
        throw new Error(`Can not find target element: ${selectName}`);
    } else if (selectElems.length > 1) {
        throw new Error(`more than one select element find: ${selectName}`);
    }
    let selectElem = selectElems[0] as HTMLSelectElement;
    if (selectElem.nodeName !== "SELECT") {
        throw new Error(`the target element (${selectName}) has to be a select element`);
    }
    let showValue = targetElem.dataset['gsShowValue'];
    let showRegexText = targetElem.dataset['gsShowRegex'];
    let hideValue = targetElem.dataset['gsHideValue'];
    let hideRegexText = targetElem.dataset['gsHideRegex'];
    let gsNameSubSelect = targetElem.dataset['gsNameSubSelect'];
    let gsNameSkip = targetElem.dataset['gsNameSkip'];
    let conditions = 0;
    let matchFn: (value: string) => boolean = null;
    let negative = false;
    if (showValue !== undefined) {
        conditions++;
        matchFn = (value) => {
            return value === showValue;
        }
    }
    if (hideValue !== undefined) {
        conditions++;
        matchFn = (value) => {
            return !value || value === hideValue;
        }
        negative = true;
    }
    if (showRegexText !== undefined) {
        conditions++;
        let regex = new RegExp(showRegexText);
        matchFn = (value) => {
            return regex.test(value);
        }
    }
    if (hideRegexText !== undefined) {
        conditions++;
        let regex = new RegExp(hideRegexText);
        matchFn = (value) => {
            return regex.test(value);
        }
        negative = true;
    }
    if (gsNameSubSelect !== undefined) {
        conditions++;
        const subSelections = (window as any)[gsNameSubSelect] as Map<string, string[]>;
        if (!subSelections) {
            throw new Error(`data-gs-name provided but can not find the name in window`)
        }
        matchFn = (value) => {
            return subSelections[value] !== undefined
        }
    }
    if (gsNameSkip !== undefined) {
        conditions++;
        const skips = (window as any)[gsNameSkip] as string[];
        if (!skips) {
            throw new Error(`data-gs-name-skip provided but can not find the name ${gsNameSkip} in window`)
        }
        if (!Array(skips)) {
            throw new Error(`data-gs-name-skip name ${gsNameSkip} in window is not an array`)
        }
        matchFn = (value) => {
            return !skips.includes(value);
        }
    }

    if (conditions !== 1) {
        throw new Error(`For show-depends-on-select, please provide exact one data-gs-show-value, data-gs-hide-value, data-gs-show-regex and data-gs-hide-regex, data-gs-name-sub-select, data-gs-name-skip attribute, ${conditions} found.`);
    }
    selectElem.addEventListener('change', (event) => {
        //console.log("change event");
        let selectedOptions = (<HTMLSelectElement>event.target).selectedOptions;
        let matched = false;
        for (let i = 0; i < selectedOptions.length; ++i) {
            let value = selectedOptions[i].value;
            if (matchFn(value)) {
                matched = true;
                break;
            }
        }
        if (negative) {
            matched = !matched;
        }
        if (matched) {
            show(targetElem);
        } else {
            hide(targetElem);
        }
    });
    trigger(selectElem, 'change', { detail: { init: true } });
}